import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { isActiveLink } from "../../utils/linkActiveChecker";

// Small one-item hover dropdown for the "Loty" nav entry. Unlike CategoriesMegaMenu
// (a wide, image-illustrated grid), this only needs a single link, so it renders a
// compact list rather than reusing the full mega__grid/mega__image layout.
const FlightsMegaMenu = () => {
  const { pathname } = useLocation();

  return (
    <ul className="mega__content">
      <li className="mega__grid" style={{ gridTemplateColumns: "auto" }}>
        <div className="mega__item">
          <div className="y-gap-5 text-15 pt-5">
            <div className={isActiveLink("/best-flights", pathname) ? "current" : ""}>
              <Link to="/best-flights">Najlepsze loty</Link>
            </div>
          </div>
        </div>
      </li>
    </ul>
  );
};

export default FlightsMegaMenu;
